import { render } from "./PrintBatchBarcode.vue?vue&type=template&id=7135ddcc&scoped=true"
import script from "./PrintBatchBarcode.vue?vue&type=script&lang=js"
export * from "./PrintBatchBarcode.vue?vue&type=script&lang=js"

import "./PrintBatchBarcode.vue?vue&type=style&index=0&id=7135ddcc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7135ddcc"]])

export default __exports__